module.exports = __webpack_public_path__ + "static/img/wheel-pan.5b2d1d3e.png";